class DateSearchFacet {
    constructor(facet, $element, options) {
        this.facet = facet;
        this.$element = $element;
        this.options = options;

        this._defaultOption = document.createElement('option')
        this._defaultOption.textContent = options.placeholder;
        this._defaultOption.value = '';
    }

    async _refreshFacetValues() {
        const { index } = this.engine;
        const { facetHits } = await index.searchForFacetValues(this.facet, '', {
            filters: this.engine.getGlobalFacetFilters()
        });

        const $children = facetHits.map(({ value }) => {
            const $child = document.createElement('option');
            $child.textContent = value;
            $child.value = value;
            return $child;
        })
        
        this.$element.replaceChildren(this._defaultOption, ...$children);
        this._defaultOption.selected = true;
    }

    bind(engine) {
        this.engine = engine;
        this.$element.addEventListener('change', this.onChange.bind(this));
        this._refreshFacetValues();
    }

    unbind(engine) {
        this.engine = null;
        this.$element.removeEventListener('change', this.onChange);
    }

    getFilter() {
        const timestampFrom = new Date('2021').getTime() / 1000;
        const timestampTo = new Date('2022').getTime() / 1000;

        return `${this.facet}:${timestampFrom} TO ${timestampTo}`;
    }

    onChange(e) {
        this.engine.update();
    }
}